import { FilterEvent, OriginalEventType } from './FilterEvent';

export class FilterDisableEvent<E extends OriginalEventType> extends FilterEvent<undefined, E> {
    constructor(originalEvent?: E | undefined) {
        super(originalEvent, undefined);
    }
}
